
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { CommonService } from 'src/app/shared/common/common.service';
import { filter, take, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CamService } from 'src/app/services/camService/cam.service';
import { ContentService } from '../../services/content.service';
import { TravelerManagement } from 'src/app/services/dataLayer/CAM/traveler-management.service';
import { NgIf } from '@angular/common';
import { ToastMessageComponent } from '../../../../shared/components/toast-message/toast-message.component';
import { MenuNavTravelerComponent } from '../menu-nav-traveler/menu-nav-traveler.component';

@Component({
    selector: 'app-traveler-details',
    templateUrl: './traveler-details.component.html',
    styleUrls: ['./traveler-details.component.scss'],
    imports: [NgIf, ToastMessageComponent, MenuNavTravelerComponent, RouterOutlet]
})
export class TravelerDetailsComponent implements OnInit {
  userId: any;
  guid: any;
  heading: boolean = false;
  sidebar!: boolean;
  showToastMessage: boolean = true;
  descriptionData: string = '';
  
  private destroy$ = new Subject<void>();
  content:any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _CommonService: CommonService,
    private _CamService:CamService,
    private contentService:ContentService,
    private readonly travelerManagement:TravelerManagement
  ) { }

   ngOnInit(): void {
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.content = res;
   
    })
      this._CamService.dataNotSaved.subscribe(data =>{
      this.sidebar = data
    })

    this.route.paramMap.subscribe(params => {
      // Handle params if needed
    });
    this.heading = this._CommonService.getData('heading');
    this.sidebar = this._CommonService.getData('camSidebar') ?? true; // Fallback to true if undefined

    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    ).subscribe((event: NavigationEnd) => {
      // Hide toast ONLY on '/personal-info', show everywhere else (including '/dependent-form')
      this.showToastMessage = !this.isPersonalInfoRoute(event.url);
    // this.travelerManagement.traveler_menu_click();
    });

    // Initial check
    this.showToastMessage = !this.isPersonalInfoRoute(this.router.url);

  
  }

  private isPersonalInfoRoute(url: string): boolean {
    // Check if URL contains '/personal-info' (case-sensitive)
    return url.includes('/personal-info');
  }

}
